import { GET } from "../API";
let source = null;
let sourceCall = null;
let sourceVideoTool = null;

export const getTranslationsLanguagesAPI = (onSuccess, onError) => {
    source = GET(`/api/v1/identity/users/translation_languages`, onSuccess, onError, true, source);
}
export const getCallLanguagesAPI = (onSuccess, onError) => {
    sourceCall = GET(`/api/v1/identity/users/call_languages`, onSuccess, onError, true, sourceCall);
}
export const getVideoToolLanguagesAPI = (onSuccess, onError) => {
    sourceVideoTool = GET(`/api/v1/identity/users/video_tool_languages`, onSuccess, onError, true, sourceVideoTool);
}